(function() {
  'use strict';

  var studies = document.querySelectorAll('[data-dsr-study]');
  if (!studies.length) return;

  if (!('IntersectionObserver' in window)) {
    studies.forEach(function(s) { s.setAttribute('data-in-view', 'true'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.setAttribute('data-in-view', 'true');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3, rootMargin: '0px 0px -10% 0px' });

  studies.forEach(function(s) { observer.observe(s); });
})();
